import React from "react";

import { Styles, withStyles } from "./styles";

const HeroContainerBase: React.FC<Styles> = ({ classes, children }) => (
  <div className={classes.container}>{children}</div>
);

export const HeroContainer = withStyles(HeroContainerBase);
